import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUploadedNoteId, getRmsAppCode, isSending } from "../../../../reducers";
import { DataTypes } from "../../../../constants";
import { addNote, getNoteDetails, updateNote } from "../../../../actions/rmsActions";
import NoteFormDialog from "./NoteFormDialog";

function NoteForm({ onClose, note, ...props }) {
    const [title, setTitle] = useState(note ? note.title : "");
    const handleSetTitle = (event) => setTitle(event.target.value);
    const [content, setContent] = useState(note ? note.description : "");
    const handleSetContent = (event) => setContent(event.target.value);

    const uploading = useSelector((state) => isSending(state, DataTypes.NOTE));
    const uploaded = useSelector(getUploadedNoteId);
    const appCode = useSelector(getRmsAppCode);

    const dispatch = useDispatch();

    const handleUpload = () => {
        if (!!note && !!note.id) {
            dispatch(updateNote(appCode, note.id, title, content));
        } else {
            dispatch(addNote(appCode, title, content));
        }
    };

    useEffect(() => {
        if (!uploading && !!uploaded && !!appCode) {
            dispatch(getNoteDetails(uploaded, appCode));
            onClose();
        }
    }, [uploading, uploaded, onClose, dispatch, appCode]);

    return (
        <NoteFormDialog
            action={!!note ? "Edit" : "Add"}
            confirmButton={!!note ? "Save" : "Add"}
            type="note"
            onClose={onClose}
            title={title}
            setTitle={handleSetTitle}
            content={content}
            setContent={handleSetContent}
            isUploading={uploading}
            onUpload={handleUpload}
            {...props}
        />
    );
}

export default NoteForm;
